export const focusSteps = [
    {
        id: 'idiomas',
        title  : 'WIZARD.CERTIFICAR.STEPS.STP1.WIZBT',
        videoBanner: 'idiomas',
        icon : 'language',
        ruta : './languages',
        tituloPagina: 'WIZARD.CERTIFICAR.STEPS.STP1.TITULO',
        subtiPagina: 'WIZARD.CERTIFICAR.STEPS.STP1.SUBTI',
        status : 1,
        visible: true
    },
    {
        id: 'reactivos',
        title  : 'WIZARD.CERTIFICAR.STEPS.STP1-FOCUS-PLANTILLA.WIZBT',
        videoBanner: 'reactivos',
        icon : 'sentiment_satisfied_alt',
        ruta : './reactives',
        tituloPagina: 'WIZARD.CERTIFICAR.STEPS.STP1-1.TITULO',
        subtiPagina: 'WIZARD.CERTIFICAR.STEPS.STP1-1.SUBTI',
        status : 1,
        visible: true
    },
    // {
    //     id: 'abiertas',
    //     title  : 'WIZARD.CERTIFICAR.STEPS.STP3-1.WIZBT',
    //     videoBanner: 'abiertas',
    //     icon : 'help_outline',
    //     ruta : './open',
    //     tituloPagina: 'WIZARD.CERTIFICAR.STEPS.STP3-1.TITULO',
    //     subtiPagina: 'WIZARD.CERTIFICAR.STEPS.STP3-1.SUBTI',
    //     status : 2,
    //     visible: true
    // },
    {
        id: 'adic',
        title  : 'WIZARD.CERTIFICAR.STEPS.STP4-FOCUS-PLANTILLA.WIZBT',
        videoBanner: 'adicionales',
        icon : 'note_add',
        ruta : './additionals',
        tituloPagina: 'WIZARD.CERTIFICAR.STEPS.STP4.TITULO',
        subtiPagina: 'WIZARD.CERTIFICAR.STEPS.STP4.SUBTI',
        status : 2,
        visible: true
    },
    {
        id: 'colabs',
        title  : 'WIZARD.CERTIFICAR.STEPS.STP5.WIZBT',
        videoBanner: 'colaboradores',
        icon : 'people',
        ruta : './collaborators',
        tituloPagina: 'WIZARD.CERTIFICAR.STEPS.STP5.TITULO',
        subtiPagina: 'WIZARD.CERTIFICAR.STEPS.STP5.SUBTI',
        status : 1,
        visible: true
    },
    // {
    //     id: 'grup',
    //     title  : 'WIZARD.LANDING.PRODUCTO.FOCUS.SECTION',
    //     videoBanner: '',
    //     icon : 'poll',
    //     ruta : './grupos',
    //     tituloPagina: 'WIZARD.LANDING.PRODUCTO.FOCUS.TITLE',
    //     subtiPagina: 'WIZARD.LANDING.PRODUCTO.FOCUS.SUBTI',
    //     status : 1,
    //     visible: true
    // },
    {
        id: 'prog',
        title  : 'WIZARD.CERTIFICAR.STEPS.STP6.WIZBT',
        videoBanner: 'programar',
        icon : 'date_range',
        ruta : './schedule',
        tituloPagina: 'WIZARD.CERTIFICAR.STEPS.STP6.TITULO',
        subtiPagina: 'WIZARD.CERTIFICAR.STEPS.STP6.SUBTI',
        status : 1,
        visible: true
    },
    {
        id: 'envio',
        title  : 'WIZARD.CERTIFICAR.STEPS.STP7.WIZBT',
        videoBanner: 'envio',
        icon : 'send',
        ruta : './mailSending',
        tituloPagina: 'WIZARD.CERTIFICAR.STEPS.STP7.TITULO',
        subtiPagina: 'WIZARD.CERTIFICAR.STEPS.STP7.SUBTI',
        status : 1,
        visible: true
    },
    {
        id: 'cierre',
        title  : 'WIZARD.CERTIFICAR.STEPS.STP8.WIZBT',
        videoBanner: 'cierre',
        icon : 'power_settings_new',
        ruta : './close',
        tituloPagina: 'WIZARD.CERTIFICAR.STEPS.STP8.TITULO',
        subtiPagina: 'WIZARD.CERTIFICAR.STEPS.STP8.SUBTI',
        status : 1,
        visible: true
    }

];
